/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { updateBillingDetailsDataLocaleSchema } from './UpdateBillingDetailsDataLocaleSchema'

export const updateBillingDetailsDataSchema = z.object({
	name: z.string(),
	email: z.string().email(),
	address: z.object({
		line1: z.string(),
		line2: z.string().nullable().optional(),
		city: z.string().nullable().optional(),
		state: z.string().nullable().optional(),
		postalCode: z.string(),
		country: z.union([
			z.literal('FI'),
			z.literal('AT'),
			z.literal('BE'),
			z.literal('BG'),
			z.literal('HR'),
			z.literal('CY'),
			z.literal('CZ'),
			z.literal('DK'),
			z.literal('EE'),
			z.literal('FR'),
			z.literal('DE'),
			z.literal('GR'),
			z.literal('HU'),
			z.literal('IE'),
			z.literal('IT'),
			z.literal('LV'),
			z.literal('LT'),
			z.literal('LU'),
			z.literal('MT'),
			z.literal('NL'),
			z.literal('PL'),
			z.literal('PT'),
			z.literal('RO'),
			z.literal('SK'),
			z.literal('SI'),
			z.literal('ES'),
			z.literal('SE'),
			z.literal('US'),
			z.literal('NO'),
			z.literal('GB'),
			z.literal('CH'),
		]),
	}),
	locale: updateBillingDetailsDataLocaleSchema,
	vatId: z.string().nullable().optional(),
})

export type UpdateBillingDetailsDataSchema = z.infer<typeof updateBillingDetailsDataSchema>
